<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="
                  isDeletePage() != true ? 'Store Items' : 'Deleted Store Items'
                "
              ></h3>
              <template v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/store-items/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </template>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    clearable
                    @click:clear="(filter.is_active = null), (page = 1)"
                    label="Status"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="category"
                    solo
                    rounded
                    v-model="filter.category_id"
                    :items="categories"
                    item-text="description"
                    item-value="id"
                    clearable
                    @click:clear="(filter.category_id = null), (page = 1)"
                    label="Category"
                    @input="getData"
                    prepend-inner-icon="mdi-tag"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Category-wise Store Items Display -->
      <v-row v-if="isLoading">
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row v-else>
        <v-col
          v-for="(categoryGroup, categoryName) in groupedStoreItems"
          :key="categoryName"
          md="12"
        >
          <v-card elevation="6" rounded="xxl" class="mb-4">
            <v-card-title class="primary white--text">
              <v-icon class="mr-2" color="white">mdi-tag</v-icon>
              <h3>{{ categoryName }}</h3>
              <v-spacer></v-spacer>
              <v-chip color="white" text-color="primary">
                {{ categoryGroup.items.length }} Items
              </v-chip>
            </v-card-title>
            <v-card-text>
              <v-simple-table class="striped-table">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Sr No</th>
                      <th class="text-left">Status</th>
                      <th class="text-left">Image</th>
                      <th class="text-left">Item Name</th>
                      <th class="text-left">Coin</th>
                      <th class="text-left">Expiry Days</th>
                      <!-- <th class="text-right">Action</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, i) in categoryGroup.items"
                      :key="`item_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                      }"
                    >
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="item.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Store Item is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="item.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Store Item is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <v-avatar size="50" v-if="item.image_file">
                          <v-img :src="`${mediaUrl}${item.image_file}`"></v-img>
                        </v-avatar>
                        <v-avatar size="50" v-else color="grey lighten-2">
                          <v-icon>mdi-image-off</v-icon>
                        </v-avatar>
                      </td>
                      <td>
                        {{ item.name || "" }}
                      </td>
                      <td>
                        <v-chip small color="amber" text-color="white">
                          <v-icon left small>mdi-bitcoin</v-icon>
                          {{ item.coin || 0 }}
                        </v-chip>
                      </td>
                      <td>
                        {{ item.expairy_days || 0 }} Days
                      </td>
                      <!-- <td class="text-right">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Delete_this(item.id)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this Store Item</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Restore_this(item.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this store item</span>
                          </v-tooltip>
                        </template>
                      </td> -->
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-divider class="my-3"></v-divider>
              <!-- <div class="text-right" v-if="isDeletePage() != true">
                <v-btn
                  color="primary"
                  rounded
                  @click="editCategory(categoryGroup.categoryId, categoryName)"
                >
                  <v-icon left>mdi-pencil</v-icon>
                  Edit {{ categoryName }}
                </v-btn>
              </div> -->
            </v-card-text>
          </v-card>
        </v-col>

        <!-- No Data Found -->
        <v-col md="12" v-if="Object.keys(groupedStoreItems).length === 0">
          <v-card elevation="6" rounded="xxl">
            <v-card-text class="text-center">
              <v-icon size="64" color="grey">mdi-package-variant-closed</v-icon>
              <h3 class="mt-3">No store items found</h3>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Pagination -->
      <v-row v-if="!isLoading && Object.keys(groupedStoreItems).length > 0">
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Delete Success Dialog Box -->
      <v-dialog v-model="is_deleted_item" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Store Item deleted successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_deleted_item = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_item" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Store Item restored successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_restored_item = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "storeItemsPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
        company_id: "",
        category_id: "",
      },
      storeItems: [],
      companies: [],
      categories: [],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
        Company: "company_name",
        Coin: "coin",
        "Expiry Days": "expairy_days",
      },
      isLoading: false,
      isExcelloading: false,
      delete_item: false,
      restore_item: false,
      is_deleted_item: false,
      is_restored_item: false,
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  computed: {
    groupedStoreItems() {
      // Group store items by category
      const grouped = {};
      this.storeItems.forEach((item) => {
        const categoryName = item.category ? item.category.description : "Uncategorized";
        const categoryId = item.category ? item.category.id : null;

        if (!grouped[categoryName]) {
          grouped[categoryName] = {
            categoryId: categoryId,
            categoryName: categoryName,
            items: [],
          };
        }
        grouped[categoryName].items.push(item);
      });
      return grouped;
    },
  },
  mounted() {
    this.getData();
    this.getCompanies();
    this.getCategories();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.company_id = this.filter.company_id
        ? this.filter.company_id
        : "";
      this.filter.category_id = this.filter.category_id
        ? this.filter.category_id
        : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&company_id=" +
        this.filter.company_id +
        "&category_id=" +
        this.filter.category_id +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`store_items?${query}`)
        .then((response) => {
          this.storeItems = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },
    async getCompanies() {
      try {
        const response = await axios.get("/companies");
        this.companies = response.data.data;
      } catch (e) {
        console.log(e);
      }
    },
    async getCategories() {
      try {
        const response = await axios.get("/masters?context=category");
        this.categories = response.data.category;
      } catch (e) {
        console.log(e);
      }
    },
    //Generate Excel
    async generateExcel() {
      let query = "search_keyword=" + this.filter.search_keyword;
      let response = await axios.get(`store_item_exports?${query}`);
      console.log(response.data.data);
      if (response) {
        window.open(`${response.data.data}`, "_blank");
      }
    },
    async Delete_this(id) {
      this.delete_item = true;
      await axios
        .post(`/store_items/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_item = false;
          this.is_deleted_item = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
    async Restore_this(id) {
      this.restore_item = true;
      await axios
        .post(`/store_items/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_item = false;
          this.is_restored_item = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
    },
    editCategory(categoryId, categoryName) {
      // Navigate to edit page with category ID
      this.$router.push({
        path: `/store-items/category/${this.encryptIt(categoryId)}`,
        query: { name: categoryName }
      });
    },
  },
};
</script>
